import { Input } from "design-react-kit";
import { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import Select from "../../Components/Select";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import { AlertMessage, showError } from "../../Components/AlertMessage";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NewExcutive(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [validationPiva, setValidationPiva] = useState();
  const [servizioEsercente, setServizioEsercente] = useState();

  const [apiError, setApiError] = useState({});

  let query = useQuery();

  const [data, setData] = useState({
    name: null,
    pIva: null,
    address: null,
    note: null,
    serviceId: null,
    serviceName: null,
  });

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      setServizioEsercente(selectedOption);
      setData({
        ...data,
        serviceId: selectedOption.value,
        serviceName: selectedOption.label,
      });
    } else {
      setServizioEsercente(selectedOption);
      setData({
        ...data,
        serviceId: null,
        serviceName: null,
      });
    }
  };

  useEffect(() => {
    Repo.getListaServizi(apiToken)
      .then((response) => {
        setServizi(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const newUserValidation = () => {
    const regexPiva = /^[0-9]{11}$/;
    setValidation(true);
    let passedValidation = false;
    let passedValidationPIVA = false;

    if (data.pIva && data.pIva.match(regexPiva)) {
      passedValidationPIVA = true;
      setValidationPiva(true);
    } else {
      passedValidationPIVA = false;
      setValidationPiva(false);
    }

    if (
      data.name &&
      data.pIva &&
      passedValidationPIVA &&
      data.address &&
      servizioEsercente
    ) {
      passedValidation = true;
    }

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const handleAlertClose = () => {
    setApiError({ isVisible: false, message: "" });
  };

  // API inserimento esercente
  const insertExecutiveAPI = () => {
    Repo.addNewExecutiveInfoByOperator(apiToken, JSON.stringify(data))

      .then((response) => {
        if (response.status === 200) {
          window.location.href = props.subfolder + "/esercenti";
        }
      })
      .catch((error) => {
        toggleModal(!isOpen);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  return (
    <>
      <div>
        {apiError.isVisible && (
          <AlertMessage
            isVisible={apiError.isVisible}
            error={apiError.message}
            onClose={handleAlertClose}
          />
        )}

        <h1>Nuovo Esercente</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Inserisci un nuovo esercente</p>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-6">
              <Input
                id="name"
                required
                label="Nome*"
                type="text"
                name="name"
                {...(validation &&
                  !data.name && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                onChange={(e) => setData({ ...data, name: e.target.value })}
              />
            </div>
            <div className="col-lg-6">
              <Input
                id="pIva"
                required
                label="P. IVA*"
                type="text"
                name="last_name"
                onChange={(e) => setData({ ...data, pIva: e.target.value })}
                {...(validation &&
                  !data.pIva && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                {...(validationPiva === false &&
                  data.pIva && {
                    infoText: "Il campo non non ha un valore valido!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-12">
              <Input
                id="note"
                required
                label="Note"
                type="text"
                name="note"
                onChange={(e) => setData({ ...data, note: e.target.value })}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12">
              <Input
                id="address"
                required
                label="Indirizzo*"
                type="text"
                name="address"
                onChange={(e) => setData({ ...data, address: e.target.value })}
                {...(validation &&
                  !data.address && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12">
              <Select
                aria-label="Scegli una categoria*"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                icon={false}
                name="servizio"
                id="servizio"
                onChange={handleSelectChange}
                options={servizi}
                value={servizioEsercente || ""}
                isClearable
                isSearchable
                placeholder={"Scegli una categoria"}
              />
              {validation && !servizioEsercente ? (
                <small id="errorSelect" className="form-text text-danger">
                  Il campo non può essere vuoto!
                </small>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div className="row my-2">
          <div className="col-lg-12 text-right">
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => newUserValidation()}
              title="Conferma"
            >
              Conferma
            </button>
          </div>
        </div>

        <ModalComponent
          toggleModal={toggleModal}
          isOpen={isOpen}
          header="Inserimento nuovo utente"
          body="Confermi di voler inserire un nuovo utente?"
          buttonConfirm="Conferma"
          buttonDeny="Annulla"
          function={() => insertExecutiveAPI()} //api inserimento esercente
        ></ModalComponent>
      </div>
    </>
  );
}

export default NewExcutive;
